"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementDatasetsApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var MeasurementDatasetsApi = /** @class */ (function (_super) {
    __extends(MeasurementDatasetsApi, _super);
    function MeasurementDatasetsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a Dataset in a business account
     * Create Dataset
     */
    MeasurementDatasetsApi.prototype.createDatasetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling createDataset.');
                        }
                        if (requestParameters.createDatasetRequest === null || requestParameters.createDatasetRequest === undefined) {
                            throw new runtime.RequiredError('createDatasetRequest', 'Required parameter requestParameters.createDatasetRequest was null or undefined when calling createDataset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/datasets".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateDatasetRequestToJSON)(requestParameters.createDatasetRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DatasetFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a Dataset in a business account
     * Create Dataset
     */
    MeasurementDatasetsApi.prototype.createDataset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createDatasetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get Dataset by ID
     * Get Dataset
     */
    MeasurementDatasetsApi.prototype.getDatasetByIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getDatasetById.');
                        }
                        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
                            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDatasetById.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/datasets/{dataset_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("dataset_id", "}"), encodeURIComponent(String(requestParameters.datasetId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DatasetFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get Dataset by ID
     * Get Dataset
     */
    MeasurementDatasetsApi.prototype.getDatasetById = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDatasetByIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all Datasets delegated to an Ad Account
     * Get Datasets for Ad Account
     */
    MeasurementDatasetsApi.prototype.getDatasetsByAdAccountIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getDatasetsByAdAccountId.');
                        }
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getDatasetsByAdAccountId.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/ad_accounts/{ad_account_id}/datasets".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DatasetsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all Datasets delegated to an Ad Account
     * Get Datasets for Ad Account
     */
    MeasurementDatasetsApi.prototype.getDatasetsByAdAccountId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDatasetsByAdAccountIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all Datasets for a business
     * Get Datasets for Business
     */
    MeasurementDatasetsApi.prototype.getDatasetsByBusinessIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getDatasetsByBusinessId.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/datasets".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DatasetsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all Datasets for a business
     * Get Datasets for Business
     */
    MeasurementDatasetsApi.prototype.getDatasetsByBusinessId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDatasetsByBusinessIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get diagnostics for a dataset.
     * Get diagnostics for a dataset.
     */
    MeasurementDatasetsApi.prototype.getDiagnosticsByDatasetIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getDiagnosticsByDatasetId.');
                        }
                        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
                            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDiagnosticsByDatasetId.');
                        }
                        if (requestParameters.granularities === null || requestParameters.granularities === undefined) {
                            throw new runtime.RequiredError('granularities', 'Required parameter requestParameters.granularities was null or undefined when calling getDiagnosticsByDatasetId.');
                        }
                        queryParameters = {};
                        if (requestParameters.granularities) {
                            queryParameters['granularities'] = requestParameters.granularities.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.datasourceIds) {
                            queryParameters['datasource_ids'] = requestParameters.datasourceIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/datasets/{dataset_id}/diagnostics".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("dataset_id", "}"), encodeURIComponent(String(requestParameters.datasetId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DiagnosticsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get diagnostics for a dataset.
     * Get diagnostics for a dataset.
     */
    MeasurementDatasetsApi.prototype.getDiagnosticsByDatasetId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDiagnosticsByDatasetIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Remove integration from dataset - moves integration to its own new dataset.
     * Remove Integration From Dataset
     */
    MeasurementDatasetsApi.prototype.removeIntegrationFromDatasetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling removeIntegrationFromDataset.');
                        }
                        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
                            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling removeIntegrationFromDataset.');
                        }
                        if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
                            throw new runtime.RequiredError('integrationId', 'Required parameter requestParameters.integrationId was null or undefined when calling removeIntegrationFromDataset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/datasets/{dataset_id}/integrations/{integration_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("dataset_id", "}"), encodeURIComponent(String(requestParameters.datasetId))).replace("{".concat("integration_id", "}"), encodeURIComponent(String(requestParameters.integrationId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DatasetFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Remove integration from dataset - moves integration to its own new dataset.
     * Remove Integration From Dataset
     */
    MeasurementDatasetsApi.prototype.removeIntegrationFromDataset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeIntegrationFromDatasetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Share a dataset with an ad account within a business.
     * Share A Dataset With An Ad Account
     */
    MeasurementDatasetsApi.prototype.shareBusinessDatasetWithAdAccountRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling shareBusinessDatasetWithAdAccount.');
                        }
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling shareBusinessDatasetWithAdAccount.');
                        }
                        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
                            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling shareBusinessDatasetWithAdAccount.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/datasets/{dataset_id}/ad_accounts/{ad_account_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("dataset_id", "}"), encodeURIComponent(String(requestParameters.datasetId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Share a dataset with an ad account within a business.
     * Share A Dataset With An Ad Account
     */
    MeasurementDatasetsApi.prototype.shareBusinessDatasetWithAdAccount = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shareBusinessDatasetWithAdAccountRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Unshare a dataset with an ad account within a business.
     * Unshare A Dataset With An Ad Account
     */
    MeasurementDatasetsApi.prototype.unshareBusinessDatasetWithAdAccountRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling unshareBusinessDatasetWithAdAccount.');
                        }
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling unshareBusinessDatasetWithAdAccount.');
                        }
                        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
                            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling unshareBusinessDatasetWithAdAccount.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/datasets/{dataset_id}/ad_accounts/{ad_account_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("dataset_id", "}"), encodeURIComponent(String(requestParameters.datasetId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Unshare a dataset with an ad account within a business.
     * Unshare A Dataset With An Ad Account
     */
    MeasurementDatasetsApi.prototype.unshareBusinessDatasetWithAdAccount = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.unshareBusinessDatasetWithAdAccountRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update Dataset
     * Update Dataset
     */
    MeasurementDatasetsApi.prototype.updateDatasetByIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling updateDatasetById.');
                        }
                        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
                            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling updateDatasetById.');
                        }
                        if (requestParameters.updateDatasetRequest === null || requestParameters.updateDatasetRequest === undefined) {
                            throw new runtime.RequiredError('updateDatasetRequest', 'Required parameter requestParameters.updateDatasetRequest was null or undefined when calling updateDatasetById.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/datasets/{dataset_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("dataset_id", "}"), encodeURIComponent(String(requestParameters.datasetId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateDatasetRequestToJSON)(requestParameters.updateDatasetRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DatasetFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update Dataset
     * Update Dataset
     */
    MeasurementDatasetsApi.prototype.updateDatasetById = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateDatasetByIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return MeasurementDatasetsApi;
}(runtime.BaseAPI));
exports.MeasurementDatasetsApi = MeasurementDatasetsApi;
